<template>
      <!-- 综合弹框 -->
  <div class="usertanbox">
    <div class="userbox">
      <div class="userbox_topbox">
        <img
          class="usertopbox_img1"
          src="@/assets/images/system/Users/titleguoducolor.png"
          alt=""
        />
        <div class="usertopbox_title">修改密码</div>
        <img
          class="usertopbox_img2"
          @click="passwordqx()"
          src="@/assets/images/system/Users/zdelete.png"
          alt=""
        />
      </div>
      <div class="borderbottom"></div>
      <div class="userbox_bodybox">
        <div class="userbodybox_inputbox">
          <div class="tinputname">账号</div>
          <!-- <el-input
            class="tinput"
            v-model="passwordjson.username"
            placeholder="请输入内容"
          ></el-input> -->
          <div class="tinput">{{passwordjson.username}}</div>
        </div>
        <div class="userbodybox_inputbox ubbox_inputbox_padd">
          <div class="tinputname">旧密码</div>
          <el-input
            class='tinput'
            v-model="passwordjson.oldpassword"
            show-password
            placeholder="请输入内容"
          ></el-input>
        </div>
        <div class="userbodybox_inputbox">
          <div class="tinputname">新密码</div>
          <el-input
            v-model="passwordjson.password"
            show-password
            placeholder="请输入内容"
            :class="[
              'tinput',
              passwordjson.passwordshow == false ? 'tinput_sb' : '',
            ]"
          ></el-input>
          <transition>
            <div
              v-show="passwordjson.passwordshow == false"
              class="showtitle_sb"
            >
              新密码格式输入错误(密码至少包含数字、大小写字母和特殊字符，长度至少8位)
            </div>
          </transition>
        </div>
        <div class="userbodybox_inputbox ubbox_inputbox_padd">
          <div class="tinputname">再次输入密码</div>
          <el-input
            v-model="passwordjson.newpassword"
            :class="[
              'tinput',
              passwordjson.newpasswordshow == false ? 'tinput_sb' : '',
            ]"
            show-password
            placeholder="请输入内容"
          ></el-input>
          <transition>
            <div
              v-show="passwordjson.newpasswordshow == false"
              class="showtitle_sb"
            >
              二次密码输入不相同
            </div>
          </transition>
        </div>
      </div>
      <div class="borderbottom borderbottomzh"></div>
      <div class="userbox_fotbox">
        <el-button
          size="small"
          @click="zongheclick()"
          class="userbox_but"
          type="primary"
          >确认修改</el-button
        >
        <el-button size="small" @click="passwordqx()" class="userbox_but"
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { httpToken } from "@/utils/http";
import qs from "qs";
import { checkisnull} from "@/utils/util";
import { encryption } from '@/utils/encryption/encryption.js'
export default {
  watch: {
    "passwordjson.password": {
      handler(newName) {
        if (newName == "") {
          this.passwordjson.passwordshow = true;
        } else {
          this.passwordjson.passwordshow = this.passwordyz(newName);
          if (this.passwordjson.newpassword == this.passwordjson.password) {
            this.passwordjson.newpasswordshow = true;
          } else {
            this.passwordjson.newpasswordshow = false;
          }
        }
      },
    },
    "passwordjson.newpassword": {
      handler() {
        if (this.passwordjson.newpassword == this.passwordjson.password) {
          this.passwordjson.newpasswordshow = true;
        } else {
          this.passwordjson.newpasswordshow = false;
        }
      },
    },
    deep: true,
  },
  data() {
    return {
      username: "admin",
      //  修改密码弹框状态  1为修改密码开启 0为关闭
      // tankindex: 0,
      passwordjson: {},
    };
  },
  mounted() {
    //修改密码数据重置
    this.passwordret();
  },
  methods:{
    passwordyz(val, creg) {
      // 新密码格式输入错误(密码至少包含数字和大小写字母，长度为6-20)
      // let reg = new RegExp("^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$");
      let reg = new RegExp("^(?![A-Za-z0-9]+$)(?![a-z0-9\\W]+$)(?![A-Za-z\\W]+$)(?![A-Z0-9\\W]+$)[a-zA-Z0-9\\W]{8,20}$");
      
      if (creg) {
        reg = creg;
      }
      return reg.test(val);
    },
    passwordret() {
      this.passwordjson = {
        userId: JSON.parse(sessionStorage.user).id,
        username: JSON.parse(sessionStorage.user).username,
        password: "",
        newpassword: "",
        oldpassword: "",
        passwordshow: true,
        newpasswordshow: true,
      };
    },
    // 综合弹框保存 1为修改密码开启   3 为删除 0为关闭
    zongheclick() {
      let that = this;
      let passwordjson = this.passwordjson;
      if (checkisnull(passwordjson.userId)) {
        this.$message({
          message: "ID不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(passwordjson.password)) {
        this.$message({
          message: "新密码不能为空",
          type: "warning",
        });
        return;
      }
      if (checkisnull(passwordjson.newpassword)) {
        this.$message({
          message: "请再次输入密码",
          type: "warning",
        });
        return;
      }
      if (checkisnull(passwordjson.oldpassword)) {
        this.$message({
          message: "旧密码不能为空",
          type: "warning",
        });
        return;
      }
      var reg = new RegExp("^(?![A-Za-z0-9]+$)(?![a-z0-9\\W]+$)(?![A-Za-z\\W]+$)(?![A-Z0-9\\W]+$)[a-zA-Z0-9\\W]{8,20}$");
      // passwordjson.password passwordjson.newpassword
      if (reg.test(passwordjson.password) == false) {
        this.$message({
          message: "新密码格式输入错误(密码至少包含 数字、大小写字母和特殊字符，长度至少8位)",
          type: "warning",
        });
        return;
      }
      if (passwordjson.password !== passwordjson.newpassword) {
        this.$message({
          message: "两次密码输入不相同",
          type: "warning",
        });
        return;
      }
      const newuser = encryption({
        data: { password: passwordjson.newpassword },
        key: 'thanks,pig4cloud',
        param: ['password']
      })
      const olduser = encryption({
        data: { password: passwordjson.oldpassword },
        key: 'thanks,pig4cloud',
        param: ['password']
      })
      httpToken({
        url: "/sys-user/modifyPwdByUserId",
        method: "post",
        data: qs.stringify({
          newPwd: newuser.password,
          oldPwd: olduser.password,
          userId: passwordjson.userId,
        }),
      }).then((res) => {
        if (res.data.code == 200) {
          that.$message({
            message: "密码修改成功",
            type: "success",
          });
        }
      });
      this.passwordqx();
    },
    // 综合弹框取消
    passwordqx() {
      this.$emit("showidemit");
    },
  }
}
</script>

<style lang="scss">
.usertanbox{
  .v-enter,
  .v-leave-to {
    /* 刚进入时或完全离开后透明度为0 */
    opacity: 0;
  }
  .v-enter-active,
  .v-leave-active {
    /* 设置过渡 */
    transition: all 0.5s linear;
  }
  .v-enter-to,
  .v-leave {
    /* 刚离开时或完全进入后透明度为1 */
    opacity: 1;
  }
}
.tinput_sb {
  ::v-deep.el-input__inner {
    border-color: red !important;
  }
}
.showtitle_sb {
  width: 96%;
  font-size: 14px;
  margin-top: 10px;
  color: red;
}
// 综合弹框
.usertanbox {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.25);
  z-index: 999;
  line-height: 20px;
  .userbox {
    width: 520px;
    // height: 388px;
    position: relative;
    top: calc(50vh - 235.5px);
    margin: 0 auto;
    background-color: #fff;
    .userbox_deletebox {
      box-sizing: border-box;
      padding-top: 24px;
      padding-left: 28px;
      display: flex;
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      span {
        line-height: 24px;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #1b1b1b;
      }
    }
    .userbox_listbox {
      width: 100%;
      height: 230px;
      // margin-bottom: 20px;
      overflow: auto;
    }
    .userbox_bodybox {
      width: 459px;
      margin: 0 auto;
      display: flex;
      flex-wrap: wrap;
      .ubbox_inputbox_padd {
        box-sizing: border-box;
        padding-left: 23px;
      }
      .userbodybox_inputbox {
        margin-top: 22px;
        width: 50%;
        .tinputname {
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #969696;
          margin-bottom: 16px;
        }
        .tinput {
          width: 206px;
        }
      }
    }
    .userbox_passlistbox {
      box-sizing: border-box;
      padding-top: 28px;
      padding-left: 28px;
      .option {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #969696;
        margin-bottom: 18px;
      }
      .input {
        width: 459px;
        height: 36px;
        margin-bottom: 24px;
      }
    }
    .borderbottom {
      width: 100%;
      height: 1px;
      background-color: #eeeeee;
    }
    .borderbottomzh {
      margin-top: 20px;
      margin-bottom: 15px;
    }
    .userbox_fotbox {
      display: flex;
      flex-direction: row-reverse;
      box-sizing: border-box;
      padding-right: 10px;
      .userbox_but {
        margin-bottom: 16px;
        margin-right: 22px;
      }
    }
    .userbox_topbox {
      width: 433px;
      height: 72px;
      line-height: 72px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      .usertopbox_img1 {
        width: 4px;
        height: 18px;
        margin-right: 11px;
      }
      .usertopbox_title {
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #1b1b1b;
      }
      .usertopbox_img2 {
        width: 13px;
        height: 13px;
        margin-left: auto;
        cursor: pointer;
      }
    }
  }
}
</style>